var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"page-index"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('index-category-list')],1)],1),_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('index-featured-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }